import './App.css';
import { Box, Grid, Typography } from '@mui/material';
import Board from './Components/Board';
import { Route, Routes } from 'react-router-dom';
import { useState } from 'react';

function App() {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 600);

  window.addEventListener('resize', () => {
    setIsMobile(window.innerWidth <= 600);
  });

  if (isMobile) {
    return (
      <Grid container style={{ height: '100vh', backgroundColor: '#282c34' }} alignItems="center" justify="center">
        <Grid item xs={12} style={{ textAlign: 'center', padding: '20px', color: '#fff' }}>
          <Typography variant='h4' style={{ margin: 'auto', backgroundColor: '#3f51b5', borderRadius: '10px', padding: '20px' }}>
            This game is not available on mobile devices. Use landscape mode please
          </Typography>
        </Grid>
      </Grid>
    );
  }
  return (
    <Box>
      <Routes>
        <Route path='/' element={<Board />}/>
        <Route path='/:gameId' element={<Board /> }/>
      </Routes>
    </Box>
  );
}

export default App;
